// frozen_string_literal: true

import { Controller } from "@hotwired/stimulus"

// Controlador para mostrar disclaimer cuando se menciona a @rankito
export default class extends Controller {
  static values = { replyingToRankito: Boolean }

  connect() {
    // Buscar el disclaimer directamente por ID
    this.disclaimer = document.querySelector('#rankito-disclaimer-respuesta')

    // Almacenar las funciones bound como propiedades de instancia
    this.handleChangeBound = this.handleChange.bind(this)

    // Añadir listeners usando las funciones bound almacenadas
    this.element.addEventListener('trix-change', this.handleChangeBound)
    this.element.addEventListener('input', this.handleChangeBound)
    this.element.addEventListener('keyup', this.handleChangeBound)

    // Detectar envío del formulario para marcar si se mencionó a Rankito
    this.form = this.element.closest('form')
    if (this.form) {
      this.beforeSubmitBound = this.beforeSubmit.bind(this)
      this.form.addEventListener('submit', this.beforeSubmitBound)
    }

    this.checkMention()
  }

  disconnect() {
    // Limpiar listeners usando las mismas referencias de función
    this.element.removeEventListener('trix-change', this.handleChangeBound)
    this.element.removeEventListener('input', this.handleChangeBound)
    this.element.removeEventListener('keyup', this.handleChangeBound)

    // Limpiar listener del formulario
    if (this.form && this.beforeSubmitBound) {
      this.form.removeEventListener('submit', this.beforeSubmitBound)
    }
  }

  handleChange() {
    this.checkMention()
  }

  // Se ejecuta cuando el usuario escribe en Trix (método legacy, mantenemos por compatibilidad)
  trixChange() {
    this.handleChange()
  }

  checkMention() {
    if (!this.disclaimer) return

    // Para Trix, obtenemos el contenido del editor
    const text = this.element.value || this.element.textContent || this.element.innerHTML || ''
    const hasMention = text.includes("@rankito")

    // Mostrar si hay mención o si estamos respondiendo a Rankito
    if (hasMention || this.replyingToRankitoValue) {
      this.disclaimer.style.display = "block"
    } else {
      this.disclaimer.style.display = "none"
    }
  }

  // Se ejecuta antes de enviar el formulario para marcar si hay mención a Rankito
  beforeSubmit() {
    const text = this.element.value || this.element.textContent || this.element.innerHTML || ''
    const hasMention = text.includes("@rankito")

    // Verificar si estamos respondiendo a Rankito usando el valor del backend
    const isReplyingToRankito = this.replyingToRankitoValue

    if (hasMention || isReplyingToRankito) {
      // Guardar en localStorage para que persista a través de la redirección
      localStorage.setItem('rankito_mentioned', 'true')
    }
  }
}
